// swiperInit.js
import Swiper from 'swiper/bundle';
import 'swiper/css/bundle';

document.addEventListener('DOMContentLoaded', () => {
    const rpsSections = document.querySelectorAll('.related-posts-section');

    rpsSections.forEach((section) => {
        const cardSliders = section.querySelectorAll('.rrs-card-slider');

        if (cardSliders.length) {
            cardSliders.forEach(slider => {
                new Swiper(slider, {
                    loop: false,
                    slidesPerView: 'auto',
                    spaceBetween: 32,
                    navigation: {
                        prevEl: slider.querySelector('.rrs-button-prev'),
                        nextEl: slider.querySelector('.rrs-button-next'),
                    },
                    breakpoints: {
                        576: {
                            slidesPerView: 2,
                        },
                        992: {
                            slidesPerView: 3,
                        },
                        1200: {
                            slidesPerView: 4,
                        },
                    },
                });
            });
        }
    });
});